import type { PlayersApi } from "@/v2/api/metadata/players";
import { buildFeedConfigTab } from "@/v2/kits/feed-config";
import { createPlayerFeedConfigApi } from "./player-feed-config-api";

/** Saves are inline (toggle / drawer); dialog footer Save is a no-op on this tab. */
export function createFeedConfigTab(players: PlayersApi) {
  return buildFeedConfigTab(createPlayerFeedConfigApi(players));
}
